module.exports = __webpack_public_path__ + "img/ico_mea.af46d899.png";